export default {"src":"/_next/static/media/exclamation-point.0d1b86ad.svg","height":201,"width":201,"blurWidth":0,"blurHeight":0};